module.exports = __webpack_public_path__ + "static/media/home_2.49fe4842.PNG";